export const taxes: Array<number> = [
  1.065, 1.105, 1.125, 1.145, 1.165, 1.185, 1.205, 1.225, 1.245, 1.265, 1.285,
  1.305,
];